var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignInIcons(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 385.587,
    height: 137.292,
    viewBox: "0 0 385.587 137.292",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.018 1.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-191.815 -242)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.825,0A18.811,18.811,0,0,0,0,18.825C0,32.944,18.825,53.786,18.825,53.786A124.589,124.589,0,0,0,28.938,40.55c4.321-6.517,8.713-14.905,8.713-21.725A18.811,18.811,0,0,0,18.825,0Zm0,25.549a6.723,6.723,0,1,1,6.723-6.723A6.726,6.726,0,0,1,18.825,25.549Z",
    transform: "matrix(0.891, -0.454, 0.454, 0.891, 191.815, 327.193)",
    fill: "none",
    stroke: "#2cccd3",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(257.176 266.266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.544,19.171,11.25,6.315",
    transform: "translate(-0.103 -0.846)",
    fill: "none",
    stroke: "#2cccd3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.087,37.677V17.86a4.954,4.954,0,0,0-2.477-4.285L29.271,3.667a4.954,4.954,0,0,0-4.954,0L6.977,13.575A4.954,4.954,0,0,0,4.5,17.86V37.677a4.954,4.954,0,0,0,2.477,4.285l17.339,9.908a4.954,4.954,0,0,0,4.954,0L46.61,41.962A4.954,4.954,0,0,0,49.087,37.677Z",
    transform: "translate(-4.5 -3.003)",
    fill: "none",
    stroke: "#2cccd3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.905,10.44,26.53,22.949,48.155,10.44",
    transform: "translate(-4.236 1.841)",
    fill: "none",
    stroke: "#2cccd3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,42.969V18",
    transform: "translate(4.294 6.766)",
    fill: "none",
    stroke: "#2cccd3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M62.539,31.715h-1.6v-9.74a4.117,4.117,0,0,0-1.413-3.054l-10.012-9a5.1,5.1,0,0,0-3.4-1.27h-4.42V4.325A4.588,4.588,0,0,0,36.882,0H4.811A4.588,4.588,0,0,0,0,4.325V33.157a4.588,4.588,0,0,0,4.811,4.325h1.6c0,4.775,4.31,8.65,9.621,8.65s9.621-3.874,9.621-8.65H38.485c0,4.775,4.31,8.65,9.621,8.65s9.621-3.874,9.621-8.65h4.811a1.534,1.534,0,0,0,1.6-1.442V33.157A1.534,1.534,0,0,0,62.539,31.715Z",
    transform: "matrix(0.978, 0.208, -0.208, 0.978, 319.05, 68.1)",
    fill: "none",
    stroke: "#2cccd3",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,8.492V42.461l14.862-8.492,16.985,8.492,14.862-8.492V0L31.846,8.492,14.862,0Z",
    transform: "matrix(0.978, 0.208, -0.208, 0.978, 254.377, 23.114)",
    fill: "none",
    stroke: "#2cccd3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0V33.969",
    transform: "matrix(0.978, 0.208, -0.208, 0.978, 268.913, 26.204)",
    fill: "none",
    stroke: "#2cccd3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0V33.969",
    transform: "matrix(0.978, 0.208, -0.208, 0.978, 283.761, 38.042)",
    fill: "none",
    stroke: "#2cccd3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.491,25.3A12.651,12.651,0,1,0,9.84,12.651,12.654,12.654,0,0,0,22.491,25.3Zm11.245,2.811H28.9a15.293,15.293,0,0,1-12.809,0H11.245A11.245,11.245,0,0,0,0,39.359v1.406a4.218,4.218,0,0,0,4.217,4.217H40.765a4.218,4.218,0,0,0,4.217-4.217V39.359A11.245,11.245,0,0,0,33.736,28.113Z",
    transform: "translate(159.5)",
    fill: "none",
    stroke: "#2cccd3",
    strokeWidth: 3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignInIcons);
export default __webpack_public_path__ + "static/media/sign-in-icons.91f7d4cc.svg";
export { ForwardRef as ReactComponent };